import _ from 'lodash';

export const ownershipGroups = [
	{
		display: 'Independent',
		value: 'independent',
	},
	{
		display: 'Boyett',
		value: 'boyett',
	},
	{
		display: 'G&M',
		value: 'g&m',
	},
	{
		display: 'H&S',
		value: 'h&ss',
	},

	{
		display: 'Ron and Alfred',
		value: 'ronAndAlfred',
	},
	{
		display: 'Tooley',
		value: 'tooley',
	},
	{
		display: 'Falcon Fuels',
		value: 'falconFuels',
	},
	{
		display: 'David Natanzi',
		value: 'davidNatanzi',
	},
	{
		display: 'Kevin Bibayan',
		value: 'kevinBibayan',
	},
	{
		display: 'Arash Salkhi',
		value: 'arashSalkhi',
	},
	{
		display: 'Jay Bajaria',
		value: 'jayBajaria',
	},
	{
		display: 'Jivtesh Singh Gill',
		value: 'jivteshSinghGill',
	},
	{
		display: 'Chand Ravaliya',
		value: 'chandRavaliya',
	},
	{
		display: 'Jun Kim',
		value: 'junKim',
	},
	{
		display: 'Fayez Sedrak',
		value: 'fayezSedrak',
	},
	{
		display: 'Norman Adelpour',
		value: 'normanAdelpour',
	},
	{
		display: 'Saeed Kohanoff',
		value: 'saeedKohanoff',
	},
	{
		display: 'The Salems',
		value: 'theSalems',
	},
	{
		display: 'Moe Hamdi',
		value: 'moeHamdi',
	},
	{
		display: 'Amin Salkhi',
		value: 'aminSalkhi',
	},
	{
		display: 'Ralph Kim',
		value: 'ralphKim',
	},
	{
		display: 'Steve Ettah',
		value: 'steveEttah',
	},
	{
		display: 'Salim (Sam) Daher ',
		value: 'salimDaher ',
	},
	{
		display: 'Nick Fahed',
		value: 'nickFahed ',
	},
	{
		display: 'KA Management',
		value: 'kaManagement',
	},
	{
		display: 'Navjeet Chahal',
		value: 'navjeetChahal',
	},
	{
		display: 'Pouya Zarrabian',
		value: 'pouyaZarrabian',
	},
	{
		display: 'Jonathan Nik',
		value: 'jonathanNik',
	},
	{
		display: 'Alex Patel ',
		value: 'alexPatel',
	},
	{
		display: 'Eddy Brikho',
		value: 'eddyBrikho',
	},
	{
		display: 'Alfred Daher',
		value: 'alfredDaher',
	},
	{
		display: 'Ron Reger',
		value: 'ronReger',
	},
	{
		display: 'Rafi Salib',
		value: 'rafiSalib',
	},
	{
		display: 'Haddadin',
		value: 'haddadin',
	},
	{
		display: 'Andy & Kevin',
		value: 'andyAndKevin',
	},
	{
		display: 'Vikram Vohra',
		value: 'vikramVohra',
	},
	{
		display: 'Interstate Oil',
		value: 'interstateOil',
	},
].sort((a, b) => a.display.localeCompare(b.display));

export const ownershipGroupValueToDisplay = (value) => {
	if (value === 'none') {
		return 'None';
	} else {
		return _.get(_.find(ownershipGroups, { value }), 'display', 'Missing');
	}
};
